import { FC } from 'react';

import SettingsIcon from '@mui/icons-material/Settings';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import ToolCard from 'components/ToolCard';
import Button from '@mui/material/Button';

const GeneralSettingsCard: FC = () => (
  <ToolCard
    icon={<MiscellaneousServicesIcon fontSize="large" />}
    title="Bendri nustatymai"
    description="Čia rasite dažniausiai naudojamus sistemos nustatymus"
    action={
      <Button href="general" startIcon={<SettingsIcon />} size="small">
        Redaguoti
      </Button>
    }
  />
);

export default GeneralSettingsCard;
